import { cn } from '@/lib/utils';
import { getProjectColor, getProjectIcon } from '@/utils/project-identity';

export interface ProjectPickerRowProps {
  name: string;
  icon?: string | null;
  color?: string | null;
  /** Rendered after the name — platform icons, a checkmark, etc. */
  trailing?: React.ReactNode;
}

/**
 * Shared row content for "pick a project" lists (SaveToProjectMenu's
 * standalone popover, AddToProjectSubmenu's nested DropdownMenu). Kept as
 * bare content — not its own item/button — since each caller wraps it in a
 * different interactive primitive (CommandItem, DropdownMenuItem, button).
 */
export function ProjectPickerRow({
  name,
  icon,
  color,
  trailing,
}: ProjectPickerRowProps): JSX.Element {
  const ProjectIcon = getProjectIcon(icon ?? undefined);
  const colorConfig = getProjectColor(color ?? undefined);
  return (
    <>
      <ProjectIcon className={cn('size-3.5 shrink-0', colorConfig.textClass)} weight="regular" />
      <span className="truncate flex-1">{name || 'Untitled project'}</span>
      {trailing}
    </>
  );
}
